<div class="notification-to-front-create-main ui-dark-background" data-cy="notification-to-front-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="notification-to-front-header-section">
      <div class="section-header-title" data-cy="notification-to-front-title-text">
        Send notification
      </div>
      <div style="flex: 1;"></div>
    </div>
    <app-tdo-progress-spinner style="flex: 1; position: absolute; left: 580px; top: 384px;"
      *ngIf="isLoading" data-cy="notification-to-front-loading-spinner"></app-tdo-progress-spinner>
    <!--  MAIN AREA-->

    <div
      style="display: flex; flex-basis: 40px; border-radius: var(--border-radius); background-color: var(--tdo-background); margin-bottom: 3px; padding-top: 8px;" data-cy="notification-to-front-options-bar">
      <div style="flex: 1; display: flex; padding-left: 8px; padding-top: 2px;" data-cy="notification-to-front-patient-status">
        <mat-checkbox style="margin-right: 10px;" #cbhb [checked]="notificationsInfo?.isHardBall"
          (change)="onPatientStatusChange($event, 'HB')" data-cy="hb-patient">HB</mat-checkbox>
        <mat-checkbox style="margin-right: 10px;" #cbsb [checked]="notificationsInfo?.isSoftBall"
          (change)="onPatientStatusChange($event, 'SB')" data-cy="sb-patient">SB</mat-checkbox>
        <mat-checkbox style="margin-right: 10px;" #cbdneta [checked]="notificationsInfo?.isDoNotEverTreatAgain"
          (change)="onPatientStatusChange($event, 'DNETA')" data-cy="dneta-patient">DNETA</mat-checkbox>
      </div>
      <div style="flex: 1; text-align: center;" data-cy="notification-to-front-buttons">
        <button (click)="onItemsNeededClick()" class="tdo-button tdo-save" data-cy="notes-to-front-items-needed-button"
          style="margin-right: 3px; position: relative; top: -4px;">Items Needed
        </button>
        <button [disabled]="true" class="tdo-button tdo-save" data-cy="notes-to-front-timers-button"
          style="margin-left: 3px; position: relative; top: -4px;">View Timers
        </button>
      </div>
      <div style="flex: 1; text-align: right; padding-top: 2px; padding-right: 8px;" data-cy="notification-to-front-history-container">
        <mat-checkbox [(ngModel)]="isShowHistory" (ngModelChange)="onShowHistoryChange($event)" data-cy="notes-to-front-history-checkbox">Show History</mat-checkbox>
      </div>
    </div>

    <div *ngIf="!isCaseAndTeethExists"
      style="flex: 1; width: 100%; margin-top: 200px; text-align: center; font-size: 24px; color: var(--tdo-primary);" data-cy="notification-to-front-no-items-message">
      No associated work items / teeth for the selected case.<br />Click show history to show all for current patient.
    </div>
    <div *ngIf="isCaseAndTeethExists" class="section-content"
      style="flex: 1; display: flex; flex-direction: column; overflow-y: hidden;" data-cy="notification-to-front-content-section">
      <div
        style="flex: 1; border-radius: var(--border-radius); background-color: var(--tdo-background); overflow: auto; padding: 6px;" data-cy="notification-to-front-notifications-container">
        <!--        ITEM-->
        <div *ngFor="let notification of notificationsInfo?.notifications" data-cy="notification-to-front-item">
          <div (click)="onClickNotification(notification)" class="notification-container"
            [ngClass]="{'note-selected': selectedNotification === notification}" style="cursor: pointer;" data-cy="notification-to-front-item-container">
            <div
              style="font-size: 12px; color: white; padding-top: 2px; display: flex; height: 30px; background-color: var(--tdo-primary-accent); border-top-left-radius: var(--border-radius); border-top-right-radius: var(--border-radius); margin-bottom: 1px;" data-cy="notification-to-front-item-header">
              <div *ngIf="notification.dataPatientCaseWorkItemTeeth.length === 1"  data-cy="note-to-front-title"
                style="flex: 1; margin-left: 8px; padding-top: 4px; float: left; width: 33%;">Work Item / Tooth #
                {{getTeeth(notification)}}</div>
              <div *ngIf="notification.dataPatientCaseWorkItemTeeth.length < 1"  data-cy="note-to-front-title"
                style="flex: 1; margin-left: 8px; padding-top: 4px; float: left; width: 33%;"><span>&nbsp;</span>
              </div>
              <div *ngIf="notification.dataPatientCaseWorkItemTeeth.length > 1"
                style="flex: 1; margin-left: 8px; padding-top: 4px; display: flex; float: left; width: 33%;">
                <div style="flex-basis: 200px;" data-cy="note-to-front-title">Work Item / Teeth # {{getTeeth(notification)}}</div>
                <div (click)="createNewNotificationForWorkItem(notification)" data-cy="notes-add-notification-button"
                  matTooltip="Add new record for this work item" style="color: white; position: relative; top: -3px;">
                  <mat-icon>library_add</mat-icon>
                </div>
              </div>

              <div style="flex: 1; display: flex; text-align: center; padding-top: 1px; float: left; width: 33%;" data-cy="notification-to-front-case-status">
                <div style="margin-left: auto; margin-right: auto;">
                  <span style="position: relative; top: 1px; font-weight: 500;">Case Status:</span>
                  <mat-checkbox data-cy="notes-case-complete-checkbox" style="margin-left: 8px;">Complete</mat-checkbox>
                  <mat-checkbox data-cy="notes-case-no-procedure-checkbox" style="margin-left: 8px;">No Procedure</mat-checkbox>
                </div>
              </div>
              <div
                style="flex: 1; padding-top: 4px; margin-right: 8px; text-align: right; display: flex; float: right; width: 33%;" data-cy="notification-to-front-item-actions">
                <div style="flex: 1;"  data-cy="note-to-front-creation">{{getCreationString(notification)}}</div>
                <div
                  style="width: 20px; color: var(--tdo-secondary); margin-left: 8px; position: relative; top: -5px; cursor: pointer;"
                  (click)="deleteNotification(notification)" data-cy="notes-delete-notification-button"><mat-icon>delete</mat-icon></div>
              </div>
            </div>
            <div
              style="background-color: var(--tdo-primary-accent); border-bottom-left-radius: var(--border-radius); border-bottom-right-radius: var(--border-radius); padding: 4px;" data-cy="notification-to-front-item-content">
              <div style="display: flex;" data-cy="notification-to-front-appointment-selector">
                <div style="background-color: rgba(255,255,255,0.75); height: 38px; width: 215px; border-radius: 6px;">
                  <tdo-dropdown-v2 #autoAppointmentFill [isMultiSelect]="false" [isIncludeAll]="false"
                    placeholder="Auto appointment" [value]="" [datasource]="autoAppointmentFillList"
                    displayProperty="Name" placeholderPosition="none" id="autoAppointmentFillList"
                    (selectionChange)="onAutoAppointmentFillSelect($event, notification)" data-cy="notification-to-front-appointment-dropdown"></tdo-dropdown-v2>
                </div>
                <div (click)="createNewAppointment(notification)" matTooltip="Add new appointment for this work item"
                  style="color: white; position: relative; top: 7px; margin-left: 10px;" data-cy="notification-to-front-add-appointment-button">
                  <mat-icon>add_circle_outline</mat-icon>
                </div>
              </div>
              <div
                style="background-color: white; border-radius: var(--border-radius); height: 160px; margin-top: 5px; padding: 4px; display: flex;" data-cy="notification-to-front-appointment-panel">
                <div
                  style="background-color: var(--tdo-background); border-radius: var(--border-radius); display: flex; flex: 1; margin-right: 6px; overflow-y: hidden; overflow-x: auto; padding: 2px;">
                  <!--                ITEM-->
                  <div *ngFor="let appt of notification.dataNotificationToFrontAppoitments"
                    style="background-color: var(--tdo-background); flex-basis: 430px; min-width: 430px; height: 100%; margin-right: 2px; padding: 2px; border-radius: var(--border-radius);">
                    <div
                      style="display: flex; background-color: white; width: 100%; height: 100%; padding: 2px; border-radius: var(--border-radius);">
                      <div style="flex: 1;">
                        <div
                          style="display: flex; flex: 1; margin-right: 2px; padding-right: 10px; height: 34px; overflow: hidden;">
                          <div class="notification-to-front-column" style="margin-top: 3px; line-height: 1;">Next
                            Appointment:</div>
                          <div style="flex: 1; height: 30px;" class="ntf-dropdown">
                            <app-tdo-enum-select name="enumNextAppt" class="hide-underline"
                              (enumSelected)="appt.enumNextApptID = $event.ValidValueItemId; saveAppointment(appt, selectedNotification);"
                              [validValueItemId]="appt.enumNextApptID">
                            </app-tdo-enum-select>
                          </div>
                        </div>
                        <div
                          style="display: flex; flex: 1; margin-right: 2px; padding-right: 10px; height: 34px; overflow: hidden;">
                          <div class="notification-to-front-column" style="margin-top: 3px;">Length:</div>
                          <div style="flex: 1; height: 30px;" class="ntf-dropdown">
                            <app-tdo-enum-select name="enumNextApptLength"
                              (enumSelected)="appt.enumNextApptLengthID = $event.ValidValueItemId; saveAppointment(appt, selectedNotification);"
                              [validValueItemId]="appt.enumNextApptLengthID">
                            </app-tdo-enum-select>
                          </div>
                        </div>
                        <div
                          style="display: flex; flex: 1; margin-right: 2px; padding-right: 10px; height: 34px; overflow: hidden;">
                          <div class="notification-to-front-column" style="margin-top: 3px;">When:</div>
                          <div style="flex: 1; height: 30px;" class="ntf-dropdown">
                            <app-tdo-enum-select name="enumNextApptWhen"
                              (enumSelected)="appt.enumNextApptWhenID = $event.ValidValueItemId; saveAppointment(appt, selectedNotification);"
                              [validValueItemId]="appt.enumNextApptWhenID">
                            </app-tdo-enum-select>
                          </div>
                        </div>
                      </div>
                      <div
                        style="flex-basis: 1px; margin-top: 2px; margin-bottom: 2px; margin-right: 6px; background-color: var(--tdo-primary);">
                      </div>
                      <div style="flex-basis: 134px; font-size: 12px; overflow: hidden;">
                        <span style="font-weight: 500; position: relative; top: 3px;">Ops to Block</span>
                        <span matTooltip="Delete Appointment"
                          style="width: 20px; color: var(--tdo-secondary); position: relative; top: 2px; cursor: pointer;float:right"
                          (click)="deleteAppointment(appt)"><mat-icon>delete</mat-icon></span>
                        <div style="height: 73%; overflow-y: auto; margin-top: 4px;">
                          <div class="note-to-front-op-item"
                            [ngClass]="{'note-to-front-op-item-selected': isOpSelected(appt, op)}"
                            (click)="onOperatoryClick(notification, appt, op)" *ngFor="let op of operatories"
                            style="margin-bottom: 2px;">{{op.OperatoryName}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--                END ITEM-->
                </div>
                <div
                  style="background-color: var(--tdo-background); border-radius: var(--border-radius); flex-basis: 340px; display: flex;">
                  <div style="flex: 1; margin-right: 2px; display: flex; flex-direction: column; padding: 4px;">
                    <div
                      style="flex: 1; margin-bottom: 1px; background-color: white; border-radius: var(--border-radius);">
                      <textarea (appInputFinished)="onCommentInputFinish($event, notification)" class="ntf-text-area"
                        [ngModel]="getComment(notification)"></textarea>
                    </div>
                    <div
                      style="flex: 1.5; margin-top: 1px; background-color: white; border-radius: var(--border-radius); padding-left: 4px; max-height: 100%;">
                      <span style="font-size: 12px;">Call Task(s)</span>
                      <div style="display: flex; height: 30px; overflow: hidden;">
                        <div style="flex-basis: 74px; min-width: 74px;">
                          <mat-checkbox #drCallCheckbox id="drCallCheckbox" style="position: relative; top: -3px;" [checked]="notification.doctorCall"
                            (change)="onCallTaskChange($event, drCallDateTime)">Dr</mat-checkbox>
                        </div>
                        <div style="flex: 2;">

                          <div class="ntf-dropdown" style="position: relative; height: 25px; margin-right: 2px;">
                            <app-tdo-enum-select name="enumNextCallWhen" placeholder="When to call"
                              (enumSelected)="onNotificationCallTaskChange($event, drCallCheckbox, drCallDateTime)"
                              [validValueItemId]="">
                            </app-tdo-enum-select>
                          </div>
                        </div>
                        <div style="flex: 1;">
                          <mat-form-field style="width: 100%; position: relative; top: -16px">
                            <input #drCallDateTime style="font-size: 10px; width: 100%;" [value]="notification.doctorCallTime"
                              (blur)="onCallTaskTimeChange($event, drCallCheckbox)" matInput type="datetime-local"
                              placeholder="Call date / time">
                          </mat-form-field>
                        </div>
                      </div>
                      <div style="display: flex; height: 30px; overflow: hidden;">
                        <div style="flex-basis: 74px; min-width: 74px;">
                          <mat-checkbox #officeCallCheckbox id="officeCallCheckbox" style="position: relative; top: -3px;" [checked]="notification.officeCall"
                            (change)="onCallTaskChange($event, officeCallDateTime)">Office</mat-checkbox>
                        </div>
                        <div style="flex: 2;">
                          <div class="ntf-dropdown"
                            style="position: relative; height: 25px; margin-right: 2px; width: 200px;">
                            <app-tdo-enum-select name="enumNextCallWhen" placeholder="When to call"
                              (enumSelected)="onNotificationCallTaskChange($event, officeCallCheckbox, officeCallDateTime)"
                              [validValueItemId]="">
                            </app-tdo-enum-select>
                          </div>
                        </div>
                        <div style="flex: 1;">
                          <mat-form-field style="width: 100%; position: relative; top: -16px">
                            <input #officeCallDateTime style="font-size: 10px; width: 100%;" [value]="notification.officeCallTime"
                              (blur)="onCallTaskTimeChange($event, officeCallCheckbox)" matInput type="datetime-local"
                              placeholder="start date">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style="flex-basis: 20px; display: flex; flex-direction: column; color: var(--tdo-primary-accent);">
                    <div (click)="createTask(notification)" matTooltip="Create task" style="flex: 1;">
                      <mat-icon>checklist_rtl</mat-icon>
                    </div>
                    <div (click)="createInternalMessage(notification)" matTooltip="Create internal message"
                      style="flex: 1;">
                      <mat-icon>mail</mat-icon>
                    </div>
                    <div (click)="markToBeCompleted(notification)" matTooltip="Complete Note" style="flex: 1;">
                      <mat-icon>assignment_turned_in</mat-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--          Old / History per work item id-->
            <div class="indent" style="cursor: pointer; margin-top: 4px;" (click)="onClickNotification(historicNotification)"
              [ngClass]="{'note-selected': selectedNotification === historicNotification}"
              *ngFor="let historicNotification of notification.history" data-cy="notification-to-front-history-item">
              <div
                style="font-size: 12px; color: white; padding-top: 2px; display: flex; height: 30px; background-color: var(--tdo-primary); border-top-left-radius: var(--border-radius); border-top-right-radius: var(--border-radius); margin-bottom: 1px;">
                <div *ngIf="notification.dataPatientCaseWorkItemTeeth.length === 1"
                  style="flex: 1; margin-left: 8px; padding-top: 4px;">Work Item / Tooth
                  # {{getTeeth(historicNotification)}}</div>
                <div *ngIf="notification.dataPatientCaseWorkItemTeeth.length > 1"
                  style="flex: 1; margin-left: 8px; padding-top: 4px; display: flex;">
                  <div style="flex-basis: 200px;">Work Item / Teeth # {{getTeeth(historicNotification)}}</div>
                </div>
                <div style="flex: 1; display: flex; text-align: center; padding-top: 1px;">
                  <div style="margin-left: auto; margin-right: auto;">
                    <span style="position: relative; top: -2px; font-weight: 500;">Case Status:</span>
                    <mat-checkbox style="margin-left: 8px;">Complete</mat-checkbox>
                    <mat-checkbox style="margin-left: 8px;">No Procedure</mat-checkbox>
                  </div>
                </div>
                <div style="flex: 1; padding-top: 4px; margin-right: 8px; text-align: right; display: flex;">
                  <div style="flex: 1;">{{getCreationString(notification)}}</div>
                  <div
                    style="width: 20px; color: var(--tdo-secondary); margin-left: 8px; position: relative; top: -5px; cursor: pointer;"
                    (click)="deleteNotification(historicNotification)"><mat-icon>delete</mat-icon></div>
                </div>
              </div>
              <div
                style="background-color: var(--tdo-primary); border-bottom-left-radius: var(--border-radius); border-bottom-right-radius: var(--border-radius); padding: 4px;">
                <div
                  style="background-color: white; border-radius: var(--border-radius); height: 126px; margin-top: 5px; padding: 4px; display: flex;">
                  <div
                    style="background-color: var(--tdo-background); border-radius: var(--border-radius); display: flex; flex: 1; margin-right: 6px; overflow-y: hidden; overflow-x: auto; padding: 2px;">
                    <!--                ITEM-->
                    <div *ngFor="let appt of historicNotification.dataNotificationToFrontAppoitments"
                      style="background-color: var(--tdo-background); flex-basis: 430px; min-width: 430px; height: 100%; margin-right: 2px; padding: 2px; border-radius: var(--border-radius);">
                      <div
                        style="display: flex; background-color: white; width: 100%; height: 100%; padding: 2px; border-radius: var(--border-radius);">
                        <div>
                          <div
                            style="display: flex; flex: 1; margin-right: 2px; padding-right: 10px; height: 34px; overflow: hidden;">
                            <div class="notification-to-front-column" style="margin-top: 3px;">Next Appointment:</div>
                            <div style="flex: 1; position: relative; top: -20px;">
                              <app-tdo-dropdown [disabled]="true" width="150" [dataSource]="nextApptEnums"
                                [value]="getValueByKey(appt, 'enumNextApptID')"
                                (selectionChange)="onNextApptChange($event, appt)" [isObjectValue]="true"
                                dataSourceDisplayKey="ItemDisplayValue"></app-tdo-dropdown>
                            </div>
                          </div>
                          <div
                            style="display: flex; flex: 1; margin-right: 2px; padding-right: 10px; height: 34px; overflow: hidden;">
                            <div class="notification-to-front-column" style="margin-top: 3px;">Length:</div>
                            <div style="flex: 1; position: relative; top: -20px;">
                              <app-tdo-dropdown [disabled]="true" width="150" [dataSource]="nextApptLengthEnums"
                                [value]="getValueByKey(appt, 'enumNextApptLengthID')"
                                (selectionChange)="onApptLengthChange($event, appt)" [isObjectValue]="true"
                                dataSourceDisplayKey="ItemDisplayValue"></app-tdo-dropdown>
                            </div>
                          </div>
                          <div
                            style="display: flex; flex: 1; margin-right: 2px; padding-right: 10px; height: 34px; overflow: hidden;">
                            <div class="notification-to-front-column" style="margin-top: 3px;">When:</div>
                            <div style="flex: 1; position: relative; top: -20px;">
                              <app-tdo-dropdown [disabled]="true" width="150" [dataSource]="nextApptWhenEnums"
                                [value]="getValueByKey(appt, 'enumNextApptWhenID')"
                                (selectionChange)="onApptWhenChange($event, appt)" [isObjectValue]="true"
                                dataSourceDisplayKey="ItemDisplayValue"></app-tdo-dropdown>
                            </div>
                          </div>
                        </div>
                        <div
                          style="flex-basis: 1px; margin-top: 2px; margin-bottom: 2px; margin-right: 6px; background-color: var(--tdo-primary);">
                        </div>
                        <div style="flex-basis: 134px; font-size: 12px; overflow: hidden;">
                          <span style="font-weight: 500; position: relative; top: 3px;">Ops to Block</span>
                          <div style="height: 73%; overflow-y: auto; margin-top: 4px;">
                            <div *ngFor="let op of operatories" style="margin-bottom: 2px;">{{op.OperatoryName}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--                END ITEM-->
                  </div>
                  <div
                    style="background-color: var(--tdo-background); border-radius: var(--border-radius); flex-basis: 310px; display: flex;">
                    <div style="flex: 1; margin-right: 2px; display: flex; flex-direction: column; padding: 4px;">
                      <div
                        style="flex: 1; margin-bottom: 1px; background-color: white; border-radius: var(--border-radius);">
                        <textarea [readOnly]="true" (appInputFinished)="onCommentInputFinish($event, historicNotification)"
                          class="ntf-text-area" [ngModel]="getComment(historicNotification)"></textarea>
                      </div>
                      <div
                        style="flex: 1; margin-top: 1px; background-color: white; border-radius: var(--border-radius);">
                      </div>
                    </div>
                    <div
                      style="flex-basis: 20px; display: flex; flex-direction: column; color: var(--tdo-primary-accent);">
                      <div (click)="createTask(historicNotification)" matTooltip="Create task" style="flex: 1;">
                        <mat-icon>checklist_rtl</mat-icon>
                      </div>
                      <div (click)="createInternalMessage(historicNotification)" matTooltip="Create internal message"
                        style="flex: 1;">
                        <mat-icon>mail</mat-icon>
                      </div>
                      <div matTooltip="" style="flex: 1;">
                        <mat-icon>assignment_turned_in</mat-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!--        END ITEM-->
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; min-height: 46px; padding-top: 6px;" data-cy="notification-to-front-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="notification-to-front-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="notification-to-front-save-button">Ok</button>
    </div>
  </div>
</div>